// extracted by mini-css-extract-plugin
export var backupIcon = "_ss-1";
export var image = "_ss-0";